import React, { memo } from 'react'

import { func } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function ReferenceDropzone({ onBrowse }) {
  const t = useTranslation()

  return (
    <button type="button" className="visual-references__dropzone" onClick={onBrowse}>
      <span className="visual-references__dropzone-text cgt-body-base-semibold">
        {t('viewerSidebar.enhance.assist.references.dropzone.title')}
        {' '}
        {t('viewerSidebar.enhance.assist.references.dropzone.or')}
        {' '}
        <span className="visual-references__dropzone-browse">
          {t('viewerSidebar.enhance.assist.references.dropzone.browse')}
        </span>
      </span>
    </button>
  )
}

ReferenceDropzone.propTypes = {
  onBrowse: func.isRequired,
}

export default memo(ReferenceDropzone)
